import * as core from '../../../../../../../core'

import { query } from './proposal-domain-table.query'

export const RESOURCE = {
  payload: {
    alias: 'proposal.domain.table',
    description: 'Table used to display domains for a proposal',
    name: 'Proposal Domain Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
